import { useState, useEffect } from "react";
import MyTable from "../../Components/MyTable";
import Mytitle from "../../Components/Mytitle";
import ModalForm from "../../Components/ModalForm";
import MyInput from "../../Components/Myinput";
import MyButton from "../../Components/MyButton";
import API from "../../Api/axiosConfig";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen, faTrash, faEye } from "@fortawesome/free-solid-svg-icons";
import Can from "../../Components/Can";

function MoneyInvoices() {
  const [filters, setFilters] = useState({
    from: "",
    to: "",
  });
  const [appliedFilters, setAppliedFilters] = useState(null);

  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    expense_id: "",
    customer_id: "",
    amount: "",
    date: new Date().toISOString().split("T")[0],
    we: "",
    textValue: "",
    for: "",
    payment_type: "",
    invoice_number: "",
    send_type: "",
    note: "",
    type: "",
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const [editId, setEditId] = useState(null);
  const [deleteId, setDeleteId] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleting, setDeleting] = useState(false);

  const [expenses, setExpenses] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [nextInvoice, setNextInvoice] = useState();
  const [showDetailsModal, setShowDetailsModal] = useState(false);

  const [selectedMoneyInvoice, setSelectedMoneyInvoice] = useState(null);

  useEffect(() => {
    API.get("/expenses")
      .then((res) => setExpenses(res.data.data || []))
      .catch(() => toast.error("فشل تحميل المصاريف"));

    API.get("/get-all-customers")
      .then((res) => setCustomers(res.data.data || []))
      .catch(() => toast.error("فشل تحميل العملاء"));

    API.get("/next-money-invoice-number")
      .then((res) => setNextInvoice(res.data.next_invoice_number || null))
      .catch(() => toast.error("فشل تحميل رقم الفاتورة التالي"));
  }, []);

  const handleAdd = () => {
    setFormData({
      expense_id: "",
      customer_id: "",
      amount: "",
      date: new Date().toISOString().split("T")[0],
      we: "",
      textValue: "",
      for: "",
      payment_type: "",
      invoice_number: nextInvoice,
      send_type: "",
      note: "",
      type: "",
    });
    setEditId(null);
    setErrors({});
    setShowModal(true);
  };

  const handleEdit = (record) => {
    setFormData({ ...record });
    setEditId(record.uuid);
    setErrors({});
    setShowModal(true);
  };

  const handleDeleteClick = (id) => {
    setDeleteId(id);
    setShowDeleteModal(true);
  };

  const confirmDelete = async () => {
    setDeleting(true);
    try {
      await API.delete(`/money-invoices/${deleteId}`);
      console.log("تم حذف الفاتورة بنجاح");
      setRefreshKey((prev) => prev + 1);
      setShowDeleteModal(false);
      setDeleteId(null);
    } catch (err) {
      console.error(err);
      toast.error("فشل الحذف");
    } finally {
      setDeleting(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrors({});
    try {
      if (editId) {
        await API.put(`/money-invoices/${editId}`, formData);
        console.log("تم تعديل الفاتورة بنجاح");
      } else {
        await API.post("/money-invoices", formData);
        console.log("تم إضافة الفاتورة بنجاح");
      }
      setShowModal(false);
      API.get("/next-money-invoice-number")
        .then((res) => setNextInvoice(res.data.next_invoice_number || null))
        .catch(() => toast.error("فشل تحميل رقم الفاتورة التالي"));

      setRefreshKey((prev) => prev + 1);
    } catch (err) {
      if (err.response?.data?.errors) {
        setErrors(err.response.data.errors);
      } else {
        toast.error("حدث خطأ أثناء الحفظ");
      }
    } finally {
      setLoading(false);
    }
  };
  const handleSearch = () => {
    if (!filters) {
      toast.error("من فضلك اختر نوع الخزنة");
      return;
    }

    setAppliedFilters(filters);
    setRefreshKey((prev) => prev + 1);
  };
  const handleShowDetails = (moneyInvoice) => {
    setSelectedMoneyInvoice(moneyInvoice);
    setShowDetailsModal(true);
  };
  const columns = [
    {
      header: "النوع",
      accessor: (row) => (row.type === "send" ? "سند صرف" : "سند قبض"),
    },
    { header: "العميل", accessor: "customer.name" },
    { header: "المصروف", accessor: "expense.name" },
    { header: "المبلغ", accessor: "amount" },
    { header: "التاريخ", accessor: "date" },
    {
      header: "إجراءات",
      accessor: (row) => (
        <>
          <Can permission="money_invoice_show">
            <button
              className="btn btn-sm mx-1 extrabtn"
              onClick={() => handleShowDetails(row)}
              title="عرض التفاصيل">
              <FontAwesomeIcon icon={faEye} color="white" />
            </button>
          </Can>
          <Can permission="money_invoice_update">
            <button
              className="btn btn-sm btn-primary mx-1 no-style"
              onClick={() => handleEdit(row)}>
              <FontAwesomeIcon icon={faPen} />
            </button>
          </Can>
          <Can permission="money_invoice_delete">
            <button
              className="btn btn-sm btn-danger no-style"
              onClick={() => handleDeleteClick(row.uuid)}>
              <FontAwesomeIcon icon={faTrash} />
            </button>
          </Can>
        </>
      ),
      hideOnPrint: true,
    },
  ];
  return (
    <div className="container mt-5">
      <Mytitle title="السندات" />
      <div className="d-flex justify-content-between align-items-center">
        {/* <Can permission="money_invoice_create">

                    <MyButton
                        text="إضافة سند"
                        variant="success"
                        type="button"
                        className="mb-3"
                        onClick={handleAdd}
                    />
                </Can> */}

        {/* <div className="form-group" style={{width: "180px"}}>
                    <MyInput
                        as="select"
                        // label="طريقة الدفع"
                        value={formData.payment_type}
                        onChange={(e) => setFormData({ ...formData, payment_type: e.target.value })}
                        error={errors.payment_type?.[0]}
                        options={[
                            { value: "", label: "اختر طريقة الدفع" },
                            { value: "cash", label: "قبض" },
                            { value: "credit", label: "دفع" },
                            { value: "bank_transfer", label: "سند" },
                        ]}
                        disabled={editId}

                    />
                </div> */}
      </div>
      <ModalForm
        show={showDetailsModal}
        onClose={() => setShowDetailsModal(false)}
        title={`تفاصيل الفاتورة`}
        mode="print">
        {selectedMoneyInvoice ? (
          <>
            <div className="bg-white text-dark p-1" dir="rtl">
              {/* ===== العنوان ===== */}
              <h5 className="fw-bold text-center mb-4 pb-2">
                {selectedMoneyInvoice.type == "send" ? "سند صرف" : "سند قبض"}(
                {selectedMoneyInvoice.invoice_number})
              </h5>
              <div className="row">
                {/* ===== بيانات العميل ===== */}
                {selectedMoneyInvoice.type == "receive" && (
                  <div className="mb-4 col-12 col-xl-12">
                    <h6 className="fw-bolder fs-5 pb-2 mb-4">بيانات العميل:</h6>
                    <div className="d-flex justify-content-between">
                      <p>
                        <strong>الاسم :</strong>{" "}
                        {selectedMoneyInvoice.customer?.name || "-"}
                      </p>
                      <p>
                        <strong>رقم الهاتف:</strong>{" "}
                        {selectedMoneyInvoice.customer?.phone || "-----------"}
                      </p>
                    </div>
                  </div>
                )}

                {/* ===== بيانات العملية ===== */}
                <div className="mb-4 col-12 col-xl-12 mt-2">
                  <h6 className="fw-bolder pb-2 fs-5 mb-4">تفاصيل العملية: </h6>
                  <div className="d-flex justify-content-between">
                    {" "}
                    <p>
                      <strong>نوع العملية:</strong>{" "}
                      {selectedMoneyInvoice.type === "receive"
                        ? "تحصيل"
                        : "مصروف"}
                    </p>
                    <p>
                      <strong>طريقة الدفع:</strong>{" "}
                      {selectedMoneyInvoice.payment_type === "cash"
                        ? "نقدي"
                        : "تحويل بنكي"}
                    </p>
                  </div>
                  <div className="d-flex justify-content-between">
                    <p>
                      <strong>التاريخ:</strong> {selectedMoneyInvoice.date}
                    </p>
                    {selectedMoneyInvoice.type == "send" && (
                      <p>
                        <strong>إسم المصروف: </strong>
                        {selectedMoneyInvoice?.expense?.name || "-----"}
                      </p>
                    )}
                  </div>
                  <div className="d-flex justify-content-between">
                    <p>
                      <strong>ملاحظات: </strong>
                      {selectedMoneyInvoice.note
                        ? selectedMoneyInvoice.note
                        : "-------------"}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : (
          // <table className="table table-bordered">
          //   <thead>
          //     <tr>
          //       <th>التاريخ</th>
          //       <th>الموظف</th>
          //       <th>رقم الهاتف</th>
          //       <th>النوع</th>
          //       <th>القيمة</th>
          //       <th>الوصف</th>
          //     </tr>
          //   </thead>
          //   <tbody>
          //     <tr>
          //       <td>{selectedInvoice.date}</td>
          //       <td>{selectedInvoice.employee?.name}</td>
          //       <td>{selectedInvoice.employee?.phone}</td>
          //       <td>
          //         {selectedInvoice.cash_type === "cash"
          //           ? "نقدي"
          //           : selectedInvoice.cash_type === "bank"
          //           ? "تحويل بنكي"
          //           : "-"}
          //       </td>
          //       <td>{selectedInvoice.value}</td>
          //       <td>{selectedInvoice.description || "-"}</td>
          //     </tr>
          //   </tbody>
          // </table>
          <p>لا توجد بيانات متاحة.</p>
        )}
      </ModalForm>
      <ModalForm
        show={showModal}
        onClose={() => setShowModal(false)}
        title={`${editId ? "تعديل سند" : "إضافة سند"} (${
          formData.invoice_number ? formData.invoice_number : nextInvoice
        })`}
        onSubmit={handleSubmit}
        loading={loading}
        mode="form">
        <div className="form-grid">
          {/* <div className="form-group">
                        <MyInput
                            label="رقم الفاتورة"
                            value={formData.invoice_number}
                            onChange={(e) => setFormData({ ...formData, invoice_number: e.target.value })}
                            error={errors.invoice_number?.[0]}
                            disabled={!!editId}
                            />
                    </div> */}

          <div className="form-group">
            <MyInput
              as="select"
              value={formData.type}
              onChange={(e) =>
                setFormData({ ...formData, type: e.target.value })
              }
              error={errors.type?.[0]}
              options={[
                { value: "", label: "اختر النوع" },
                { value: "send", label: "سند صرف" },
                { value: "receive", label: "سند قبض" },
              ]}
              disabled={!!editId}
            />
          </div>
          {formData.type === "receive" && (
            <>
              {(formData.type === "send" || formData.type === "receive") && (
                <div className="form-group">
                  <MyInput
                    as="select"
                    value={formData.customer_id}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        customer_id: e.target.value,
                        expense_id: "",
                      })
                    }
                    error={errors.customer_id?.[0]}
                    options={[
                      { value: "", label: "اختر العميل" },
                      ...customers.map((c) => ({ value: c.id, label: c.name })),
                    ]}
                    disabled={formData.type === "send" && formData.expense_id}
                  />
                </div>
              )}
            </>
          )}

          {formData.type === "send" && (
            <div className="form-group">
              <MyInput
                // label="المصروف"
                as="select"
                value={formData.expense_id}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    expense_id: e.target.value,
                    customer_id: "",
                  })
                }
                error={errors.expense_id?.[0]}
                options={[
                  { value: "", label: "اختر المصروف" },
                  ...expenses.map((e) => ({ value: e.id, label: e.name })),
                ]}
                disabled={formData.customer_id}
              />
            </div>
          )}

          <div className="form-group">
            <MyInput
              label="المبلغ"
              type="number"
              value={formData.amount}
              onChange={(e) =>
                setFormData({ ...formData, amount: e.target.value })
              }
              error={errors.amount?.[0]}
            />
          </div>

          <div className="form-group">
            <MyInput
              label="التاريخ"
              type="date"
              value={formData.date}
              onChange={(e) =>
                setFormData({ ...formData, date: e.target.value })
              }
              error={errors.date?.[0]}
            />
          </div>

          {/* <div className="form-group">
                        <MyInput
                            label="بواسطه"
                            value={formData.payment_type}
                            onChange={(e) => setFormData({ ...formData, payment_type: e.target.value })}
                            error={errors.payment_type?.[0]}
                        />
                    </div> */}

          <div className="form-group">
            <MyInput
              label="استلمنا نحن"
              value={formData.we}
              onChange={(e) => setFormData({ ...formData, we: e.target.value })}
              error={errors.for?.[0]}
            />
          </div>
          <div className="form-group">
            <MyInput
              label="القيمة مكتوبة"
              value={formData.textValue}
              onChange={(e) =>
                setFormData({ ...formData, textValue: e.target.value })
              }
              error={errors.textValue?.[0]}
            />
          </div>
          <div className="form-group">
            <MyInput
              label="مقابل"
              value={formData.for}
              onChange={(e) =>
                setFormData({ ...formData, for: e.target.value })
              }
              error={errors.for?.[0]}
            />
          </div>

          <div className="form-group">
            <MyInput
              as="select"
              // label="طريقة الدفع"
              value={formData.payment_type}
              onChange={(e) =>
                setFormData({ ...formData, payment_type: e.target.value })
              }
              error={errors.payment_type?.[0]}
              options={[
                { value: "", label: "اختر نوع الدفع" },
                { value: "cash", label: "كاش" },
                { value: "bank_transfer", label: "تحويل بنكي" },
                { value: "card", label: "شبكة" },
              ]}
            />
          </div>

          {/* <div className="form-group">
                        <MyInput
                            label="نوع الإرسال"
                            value={formData.send_type}
                            onChange={(e) => setFormData({ ...formData, send_type: e.target.value })}
                            error={errors.send_type?.[0]}
                        />
                    </div> */}

          <div className="form-group full-width">
            <MyInput
              label="ملاحظة"
              value={formData.note}
              onChange={(e) =>
                setFormData({ ...formData, note: e.target.value })
              }
              error={errors.note?.[0]}
            />
          </div>
        </div>
      </ModalForm>

      <ModalForm
        show={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        title="تأكيد الحذف"
        onSubmit={confirmDelete}
        loading={deleting}
        mode="confirm"
        confirmText="حذف"
        cancelText="إلغاء">
        هل أنت متأكد أنك تريد حذف هذه الفاتورة؟
      </ModalForm>

      {/* <MyTable
                resource="money-invoices"
                columns={columns}
                refreshKey={refreshKey}
            /> */}

      {/* دى الطريقة القديمة بالفلتر بالتاريخ وزرار البحث */}
      {/* <div className="row flex-row-reverse mb-3">
                <div className="col-md-2">
                    <MyInput
                        label="من"
                        type="date"
                        value={filters.from}
                        onChange={(e) =>
                            setFilters({ ...filters, from: e.target.value })
                        }
                        dontShowDay={true}
                    />
                </div>

                <div className="col-md-2">
                    <MyInput
                        label="إلى"
                        type="date"
                        value={filters.to}
                        onChange={(e) =>
                            setFilters({ ...filters, to: e.target.value })
                        }
                        dontShowDay={true}
                    />
                </div>
                <div className="col-md-1 d-flex align-items-center">
                    <MyButton onClick={handleSearch} text="بحث" />
                </div>
            </div> */}

      <MyTable
        resource="money-invoices"
        columns={columns}
        refreshKey={refreshKey}
        title={"السندات"}
        // invoiceNumber={filters.invoice_number}
        filters={[
          // { type: "text", name: "invoice_number", label: "بحث برقم الفاتورة" },
          // { type: "text", name: "customer.name", label: "بحث باسم العميل" },
          {
            type: "select",
            name: "type",
            label: "نوع السند",
            options: [
              { value: "", label: "الكل" },
              { value: "receive", label: "قبض" },
              { value: "exchange", label: "صرف" },
            ],
          },
        ]}
        button={{
          text: "إضافة سند",
          onClick: handleAdd,
          variant: "success",
          permission: "money_invoice_create",
        }}
        dateFilter={{ field: "created_at", label: "تاريخ الإنشاء" }}
      />
    </div>
  );
}

export default MoneyInvoices;
